import { Icon } from "@focus/focusUI";

interface UploadDropzoneProps {
  onAddFiles: (files: FileList, operator: string) => void;
  origin?: string;
}

export const UploadDropzone = ({ onAddFiles, origin }: UploadDropzoneProps) => {
  const preventEvent = (event: React.DragEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event: React.DragEvent<HTMLElement>) => {
    preventEvent(event);

    if (origin) {
      onAddFiles(event.dataTransfer.files, origin);
    }
  };

  const handleAdd = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (origin && event.target.files) {
      onAddFiles(event.target.files, origin);
      event.target.value = "";
    }
  };

  return (
    <label
      className={`focusoc-upload-dropzone ${
        origin ? "" : "focusoc-upload-dropzone-disabled"
      }`}
      onDrop={handleDrop}
      onDragOver={preventEvent}
      onDragEnter={preventEvent}
      onDragLeave={preventEvent}
    >
      <input
        className="foc-upload_input"
        disabled={!origin}
        type="file"
        multiple
        onChange={handleAdd}
        onClick={(event) => {
          event.currentTarget.value = "";
        }}
      />
      <span className="focusoc-upload-dropzone-icon">
        <Icon icon="cloud-upload" title="Upload" />
      </span>
      <span className="mt-4 text-base font-bold text-slate-950">
        Add files or drop them here
      </span>
      <span className="mt-2 max-w-sm text-center text-sm font-medium text-slate-500">
        {origin
          ? `Files will be uploaded for ${origin}.`
          : "Select an operator before adding files."}
      </span>
    </label>
  );
};

